import React from 'react';
import PropTypes from 'prop-types';

// Components
import Service from 'components/atoms/Service';

// Constants
import { SERVICES_TYPE } from 'constants/services';

// Utils
import { calcPackageTotalPrice, canPriceCapApplyToPackage } from 'utils/prices';
import { isObjEmpty } from 'utils/varValidation';

class PackageList extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  removeOptionalServicesNotSelected = servicePoint => {
    const {
      menuType: { services }
    } = servicePoint;
    const filteredServices = services.filter(
      service => !service.selectable || service.selectByDefault
    );
    return {
      ...servicePoint,
      menuType: {
        ...servicePoint.menuType,
        services: filteredServices
      }
    };
  };

  clickHandler(menuType) {
    const { services, ...menuTypeParams } = menuType;
    const {
      servicePoint: { menuTypes, ...servicePoint },
      apptMenuType,
      setApptServicePoint,
      selectPackage,
      updateReadOnlyPackage,
      sendScheduleServiceSelectionStart
    } = this.props;
    const servicePointInfo = {
      ...servicePoint,
      menuType: {
        ...menuTypeParams,
        services: services.map(service => {
          const { ...serviceParams } = service;
          return { ...serviceParams };
        })
      }
    };

    const isQuotedPackage = !!menuType.quoteServiceId;

    if (!apptMenuType || apptMenuType.name !== servicePointInfo.menuType.name) {
      const servicePointServices = servicePointInfo.menuType.services;
      const hasOptionalServices = servicePointServices.find(
        service => service.selectable
      );
      const hasCheckedServices = servicePointServices.find(
        service => service.selectByDefault
      );
      const hasMandatoryServices = servicePointServices.find(
        service => !service.selectable
      );
      if (
        !hasMandatoryServices &&
        (hasOptionalServices && !hasCheckedServices)
      ) {
        selectPackage(menuType.description);
      } else {
        setApptServicePoint(
          this.removeOptionalServicesNotSelected(servicePointInfo)
        );
        updateReadOnlyPackage(!!isQuotedPackage);
      }
      sendScheduleServiceSelectionStart();
    } else {
      setApptServicePoint(null);
      if (isQuotedPackage) {
        updateReadOnlyPackage(false);
      }
    }
  }

  render() {
    const {
      apptMenuType,
      packagesList,
      activePromotion,
      selectPackage,
      readOnlyPackage
    } = this.props;

    const isReadOnly = false;

    return (
      <div className={'services-list'}>
        {packagesList.map(servicePackage => {
          const applyPriceCap = canPriceCapApplyToPackage(servicePackage);
          if (!servicePackage.name) {
            servicePackage.name = '';
          }
          const isSelected = Boolean(
            apptMenuType && apptMenuType.name === servicePackage.name
          );
          const totalPrice = isSelected
            ? apptMenuType.totalPrice
            : calcPackageTotalPrice(
                servicePackage.services,
                servicePackage.totalPrice
              );
          const isQuotedPackage =
            readOnlyPackage.id === servicePackage.id ||
            readOnlyPackage.name === servicePackage.name;
          const updatedPackagePrice =
            readOnlyPackage.price || readOnlyPackage.totalPrice;
          const service = {
            ...servicePackage,
            price: totalPrice,
            totalPrice,
            ...(isQuotedPackage
              ? {
                  quoteServiceId: readOnlyPackage.quoteServiceId,
                  price: updatedPackagePrice,
                  totalPrice: updatedPackagePrice
                }
              : {})
          };
          if (activePromotion) {
            service.discountedPrice = isSelected
              ? apptMenuType.discountedPrice
              : calcPackageTotalPrice(
                  servicePackage.services,
                  servicePackage.totalPrice,
                  activePromotion
                );
          }
          return (
            <Service
              key={service.description}
              service={service}
              onSelect={this.clickHandler}
              isSelected={isSelected}
              type={SERVICES_TYPE.MENU}
              isExpandable={false}
              promotion={service.promotion}
              openModal={selectPackage}
              applyPriceCap={applyPriceCap}
              readOnly={isReadOnly && !isObjEmpty(isReadOnly)}
            />
          );
        })}
      </div>
    );
  }
}

PackageList.propTypes = {
  activePromotion: PropTypes.object,
  apptMenuType: PropTypes.object,
  packagesList: PropTypes.array.isRequired,
  selectPackage: PropTypes.func.isRequired,
  servicePoint: PropTypes.object,
  setApptServicePoint: PropTypes.func.isRequired,
  isQuoteAppt: PropTypes.bool.isRequired,
  readOnlyPackage: PropTypes.object,
  updateReadOnlyPackage: PropTypes.func.isRequired,
  sendScheduleServiceSelectionStart: PropTypes.func
};

export default PackageList;



// WEBPACK FOOTER //
// ./src/components/atoms/PackageList/PackageList.js